import React from "react";
import { useLang } from "@/lib/useLang";
import { STRINGS } from "@/lib/i18n";

export const StatsBanner = ({ voted = false, frozen = false }) => {
  const { lang } = useLang();
  const dict = STRINGS[lang] || STRINGS.en;

  const scrollTo = () => {
    let target;
    if (frozen) {
      target =
        document.querySelector('[data-testid="frozen-announcement-card"]') ||
        document.querySelector('[data-testid="comparison-section"]');
    } else {
      target = voted
        ? document.querySelector('[data-testid="share-card-section"]')
        : document.querySelector('[data-testid="ballot-heading"]') ||
          document.querySelector('[data-testid="candidates-grid"]');
    }
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const label = frozen ? dict.frozen_banner_text : dict.stats_banner_text;
  const ctaText = frozen
    ? dict.frozen_banner_cta
    : voted
      ? dict.stats_banner_cta_share
      : dict.stats_banner_cta;

  return (
    <div
      className="border-b-4 border-black"
      style={{ background: "#0A0A0A", color: "#FF9933" }}
      data-testid={frozen ? "frozen-banner" : "stats-banner"}
      role="status"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <p
          className="text-sm sm:text-base font-extrabold tracking-wide"
          data-testid={frozen ? "frozen-banner-label" : "stats-banner-label"}
          style={{ color: "#FDFBF7" }}
        >
          {label}
        </p>
        <button
          onClick={scrollTo}
          className="text-xs sm:text-sm font-extrabold tracking-[0.25em] px-3 py-1 border-2 border-current shrink-0"
          style={{ background: "#FF9933", color: "#0A0A0A", borderColor: "#FF9933" }}
          data-testid={frozen ? "frozen-banner-cta" : "stats-banner-cta"}
        >
          {ctaText} →
        </button>
      </div>
    </div>
  );
};

export default StatsBanner;
